<ng-template #filterButtonRef>
  <span class="position-relative">
    <img
      class="filter-menu-icon pointer-cursor"
      (click)="accessPointActivityFilter()"
      src="assets/svg/ico-menu-circle.svg"
      alt="ico-menu-circle"
    />
    <span class="mf-badge" *ngIf="filterCount !== 0">
      <span class="circle-content">
        {{ filterCount || "" }}
      </span>
    </span>
  </span>
</ng-template>
<div
  class="building-unit-details-main"
  *ngIf="
    !sharedData?.selectedUnit?.unitId &&
    !sharedData?.selectedAccessPoint?.accessPointId
  "
>
  <app-empty-details [data]="message"></app-empty-details>
</div>

<div
  class="building-unit-details-main pl-2 mb-5 app-scrollbar"
  *ngIf="
    sharedData?.selectedUnit?.unitId ||
    sharedData?.selectedAccessPoint?.accessPointId
  "
>
  <div class="row pt-4 pb-2 px-2">
    <div class="col-2 text-center">
      <img
        src="assets/svg/ico-default-home-circle.svg"
        class="icon"
        *ngIf="sharedData?.selectedUnit?.unitId"
      />
      <img
        src="assets/images/accesspoint-icon.png"
        class="icon"
        *ngIf="sharedData?.selectedAccessPoint?.accessPointId"
      />
    </div>
    <div class="col-7 heading pl-2">
      <ng-container *ngIf="sharedData?.selectedUnit?.unitId">
        <app-with-tooltip [showHelpCursor]="true"
          >{{ 'UNIT' | translate }} {{ selectedUnit?.unitName }}</app-with-tooltip
        >
      </ng-container>
      <ng-container *ngIf="sharedData?.selectedAccessPoint?.accessPointId">
        <app-with-tooltip [showHelpCursor]="true">{{
          sharedData?.selectedAccessPoint?.accessPointName
        }}</app-with-tooltip>
      </ng-container>
    </div>
    <div class="col-3 px-3 text-right setting-icon pr-2 inter-cursor">
      <img
        (click)="onEditHandler()"
        src="assets/svg/ico-lock-access-settings.svg"
      />
    </div>
  </div>
  <hr class="divider mx-3" />

  <ng-container *ngIf="!isNestedCallActive && !accessPoints">
    <div class="d-flex flex-column">
      <div class="row mx-3 mb-3">
        <app-unit-option
          [source]="'assets/svg/ico-floor.svg'"
          [title]="unitDetails?.floorName"
          [subTitle]="'FLOOR' | translate"
          class="col-6 pr-1"
        ></app-unit-option>
        <app-unit-option
          [source]="'assets/svg/ico-lock.svg'"
          [title]="deviceCount"
          [subTitle]="'DEVICE_LOCKS' | translate"
          class="col-6 pl-1"
        ></app-unit-option>
      </div>
      <div class="row mx-3 mb-3">
        <app-unit-option
          [source]="'assets/svg/ico-building-gray.svg'"
          [title]="selectedBuilding?.buildingName"
          [subTitle]="'BUILDING' | translate"
          class="col-6 pr-1"
        ></app-unit-option>
        <app-unit-option
          [source]="'assets/svg/ico-directions.svg'"
          [title]="this.unitDetails?.wingName"
          [subTitle]="'WING' | translate"
          class="col-6 pl-1"
        ></app-unit-option>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isNestedCallActive && accessPoints">
    <div class="d-flex flex-column">
      <div class="row mx-3 mb-2">
        <app-unit-option
          [source]="'assets/svg/ico-floor.svg'"
          [title]="accessPoints?.floorName"
          [subTitle]="'FLOOR' | translate"
          class="col-6 pr-1"
        ></app-unit-option>
        <app-unit-option
          [source]="'assets/svg/ico-lock.svg'"
          [title]="partnerDeviceCount"
          [subTitle]="'DEVICES' | translate"
          class="col-6 pl-1"
        ></app-unit-option>
      </div>
      <div class="row mx-3 mb-2">
        <app-unit-option
          [source]="'assets/svg/ico-building-gray.svg'"
          [title]="selectedBuilding?.buildingName"
          [subTitle]="'BUILDING' | translate"
          class="col-6 pr-1"
        ></app-unit-option>
        <app-unit-option
          [source]="'assets/svg/ico-directions.svg'"
          [title]="accessPoints?.wingName"
          [subTitle]="'WING' | translate"
          class="col-6 pl-1"
        ></app-unit-option>
      </div>
    </div>
  </ng-container>

  <!-- tabs start  -->
  <!-- tabs end  -->
  <ng-container *ngIf="!isNestedCallActive">
    <ul
      ngbNav
      #nav="ngbNav"
      [(activeId)]="activeTab"
      class="nav-tabs w-100 mb-3"
    >
      <li *ngIf="!accessPoints" [ngbNavItem]="CONSTANTS.LOCKS">
        <a ngbNavLink>{{ 'DEVICE_LOCKS' | translate }}</a>
        <ng-template ngbNavContent>
          <!-- lock devices start -->
          <app-shared-lock-devices-list
            [deviceList]="deviceList"
          ></app-shared-lock-devices-list>
          <!-- lock devices end -->
        </ng-template>
      </li>

      <li *ngIf="accessPoints" [ngbNavItem]="CONSTANTS.DEVICE">
        <a ngbNavLink>{{ 'DEVICE' | translate }}</a>
        <ng-template ngbNavContent>
          <div class="device-listing">
            <ng-container *ngIf="isNestedSubLoaderCallActive">
              <div
                class="centered-loader d-flex flex-row justify-content-center align-items-center d-none mt-5"
              >
                <app-nested-loader></app-nested-loader>
              </div>
            </ng-container>
            <ng-container *ngIf="accessPoints && !isNestedSubLoaderCallActive">
              <div class="scroll-container">
                <div class="overflow-y">
                  <ng-container
                    *ngFor="let device of partnerDeviceList; let i = index"
                  >
                    <ng-container *ngIf="device.isvisble === true">
                      <div
                        class="d-flex flex-row justify-content-center align-items-center w-100 py-3"
                      >
                        <div class="d-flex align-items-center px-2 w-100">
                          <div class="col-2">
                            <img
                              alt="User Icon"
                              [src]="
                                getPartnerDeviceLockImg(device?.deviceState)
                              "
                              class="height-40 width-40"
                            />
                          </div>

                          <div
                            class="tab-heading d-flex flex-column justify-content-center lign-items-start col-8"
                          >
                            <b></b>
                            <span class="device-name">
                              <app-with-tooltip [showHelpCursor]="true">
                                {{ device?.deviceName }}
                              </app-with-tooltip>
                            </span>
                            <span class="device-type">
                              <b>
                                <app-with-tooltip [showHelpCursor]="true">
                                  {{ 'SERIAL_NUMBER_HASH' | translate }}
                                  {{ device?.deviceId }}
                                </app-with-tooltip></b
                              >
                            </span>
                          </div>
                          <div
                            class="col-2 d-flex flex row justify-content-center pointer-cursor"
                            *ngIf="i === 0"
                          >
                            <img
                              src="assets/svg/ico-menu-button.svg"
                              (click)="
                                navigateToPartnerDeviceInfo(
                                  device?.deviceId,
                                  device?.deviceName,
                                  device?.deviceType,
                                  CONSTANTS.ACCESSPOINT
                                )
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              <ng-container *ngIf="partnerDeviceList?.length === 0">
                <div>
                  <div class="d-flex align-items-start py-3 px-2">
                    <div class="pr-3">
                      <img
                        alt="User Icon"
                        src="assets/svg/ico-lock-circle.svg"
                        class="height-40 width-40"
                      />
                    </div>
                    <div class="tab-heading pt-2 mt-1">
                      {{ 'ASSIGN_A_DEVICE' | translate }}
                    </div>
                    <div class="ml-auto pt-2 pointer-cursor">
                      <img src="assets/svg/ico-add.svg" (click)="addDevice()" />
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="CONSTANTS.USERS">
        <a ngbNavLink>{{ 'USERS' | translate }}</a>
        <ng-template ngbNavContent>
          <app-shared-unit-users-list
            [usersList]="usersList"
          ></app-shared-unit-users-list>
        </ng-template>
      </li>
      <li
        *ngIf="accessPoints && accessPoints !== undefined"
        [ngbNavItem]="CONSTANTS.ACTIVITY_DETAIL"
      >
        <a ngbNavLink> {{ 'ACTIVITY' | translate }}</a>
        <ng-template ngbNavContent>
          <div class="container-accesspoint-activity">
            <ng-container *ngIf="isActivityNestedCallActive">
              <div class="centered h-100">
                <app-nested-loader></app-nested-loader>
              </div>
            </ng-container>
            <ng-container *ngIf="!isActivityNestedCallActive">
              <app-activity
                [activities]="restrictedAccessObservable | async"
                [entityType]="CONSTANTS.ACCESSPOINT"
                (scrollDown)="scrollDownEmitter($event)"
                [canLoad]="canLoad"
              >
                <span headerElement class="filter-activity">
                  <ng-container
                    *ngIf="(accessPointActivities | async)?.events?.length >= 0"
                  >
                    <ng-template
                      [ngTemplateOutlet]="filterButtonRef"
                    ></ng-template>
                  </ng-container>
                </span>
              </app-activity>
            </ng-container>
          </div>
        </ng-template>
      </li>
      <li *ngIf="!accessPoints" [ngbNavItem]="CONSTANTS.ACTIVITY_DETAIL">
        <a ngbNavLink> {{ 'ACTIVITY' | translate }}</a>

        <ng-template ngbNavContent>
          <div class="container-accesspoint-activity">
            <ng-container *ngIf="isActivityNestedCallActive">
              <div class="centered h-100">
                <app-nested-loader></app-nested-loader>
              </div>
            </ng-container>
            <ng-container *ngIf="!isActivityNestedCallActive">
              <app-activity
                [activities]="restrictedUnitsObservable | async"
                [entityType]="CONSTANTS.UNIT"
                (scrollDown)="scrollDownEmitter($event)"
                [canLoad]="canLoad"
              >
                <span headerElement class="filter-activity">
                  <ng-container
                    *ngIf="(unitActivities | async)?.events?.length >= 0"
                  >
                    <ng-template
                      [ngTemplateOutlet]="filterButtonRef"
                    ></ng-template>
                  </ng-container>
                </span>
              </app-activity>
            </ng-container>
          </div>
        </ng-template>
      </li>
    </ul>
    <div class="w-100 px-6 content mb-2">
      <div [ngbNavOutlet]="nav" class="mt-2 inner-container"></div>
    </div>

    <div class="row  remove-container mt-auto pb-4">
      <div class="col-12">
        <ng-container *ngIf="activeTab === CONSTANTS.ACTIVITY_DETAIL">
          <div
            *ngIf="
              (!accessPoints && (unitActivities | async)?.events?.length > 0) ||
              (accessPoints &&
                (accessPointActivities | async)?.events?.length > 0)
            "
            type="button"
            class="cursor d-flex justify-content-center align-items-center"
          >
            <p
              class="view-all-btn mt-1 mb-0 pointer-cursor"
              (click)="viewAllUnitsOrAccessPointActivity()"
            >
              {{ 'VIEW_ALL' | translate }}
            </p>
          </div>
        </ng-container>

        <ng-container *ngIf="activeTab !== CONSTANTS.ACTIVITY_DETAIL">
          <ng-container *ngIf="accessPoints">
            <div
              class="d-flex flex-row justify-content-center align-items-center d-none pb-2"
              type="button"
              (click)="onRemoveAccessPoint()"
            >
              <img src="assets/svg/ico-close-circle-outline.svg" />
              <p class="remove-btn ml-2 pt-2 pointer-cursor">
                {{ 'REMOVE_ACCESS_POINT' | translate }}
              </p>
            </div>
          </ng-container>
          <ng-container *ngIf="!accessPoints">
            <div
              class="d-flex flex-row justify-content-center align-items-center d-none pb-2"
            >
              <img src="assets/svg/ico-close-circle-outline.svg" />
              <p
                class="remove-btn ml-2 pt-2 pointer-cursor"
                (click)="onRemoveUnit()"
              >
                {{ 'REMOVE_UNIT' | translate }}
              </p>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isNestedCallActive">
    <div class="centered h-100">
      <app-nested-loader></app-nested-loader>
    </div>
  </ng-container>
</div>
